import React, {Suspense} from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DmpsIndex from '../../pages/admin/dmps/Dmps';

const Dmps = (props) => {
  const { path } = useRouteMatch();
  const { t } = useTranslation();

	return (
    <Suspense fallback={<div>{t('loading')}...</div>}>
      <Switch>
        <Route exact path={`${path}`} component={DmpsIndex}/>
      </Switch>
    </Suspense>
	)
}

export default Dmps;
